export const getTWHighlightTeamMemberClass = (obj: { Id?: string | number }, currentId: string | number) =>
    obj?.Id === currentId ? "current-team-member" : "";

export const getTWHighlightCompetitorClass = (obj: { Id?: string | number }, currentId: string | number) =>
    obj?.Id === currentId ? "current-competitor" : "";
